import { Link as RouterLink, useLocation } from 'react-router-dom';

import { landingLink } from '@/app/navigation';
import { useAuth } from '@/auth/useAuth';
import { Button } from '@/components/ui/Button';

import { StatusPage } from './StatusPage';

/**
 * Shown, inside the portal frame, for an address the route table does not
 * know. It used to fall out of the frame to a bare error page with no
 * navigation, so a mistyped address cost the person their place.
 */
export function NotFoundPage() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const back = landingLink(user?.role);

  return (
    <StatusPage
      title="Page not found"
      documentTitle="Page not found"
      address={pathname}
      testId="not-found"
      action={
        <Button
          component={RouterLink}
          to={back.to}
          variant="secondary"
          data-testid="not-found-back-link"
        >
          {back.label}
        </Button>
      }
    >
      is not a page in the portal. The address may be mistyped, or the page may have
      moved.
    </StatusPage>
  );
}
